import { createSelector } from 'reselect'
import getAccessToken from './getAccessToken'
import decodeJWT from '../modules/decodeJWT'

export default createSelector(
  getAccessToken,
  (accessToken) => accessToken && decodeJWT(accessToken).admin.avatar,
)
